<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card>
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div :class="`vx-row pb-0 ${filtroAvancado ? 'sm:pb-0' : 'sm:pb-4'}`">
          <div :class="`vx-col mt-3 sm:w-1/9 w-full`">
            <span> Nº da Cotação </span>
            <vs-input
              class="w-full"
              name="codigo"
              id="codigo"
              v-model="formFiltro.idProposta"
              :state="validateState('codigo')"
              :danger="validateClass('codigo')"
              val-icon-danger="clear"
              data-testId="proposal-id-input"
            />
          </div>
          <div :class="`vx-col mt-3 sm:w-1/9 w-full`">
            <vs-tooltip text="Insira os 6 últimos números">
              <span>
                Nº da Proposta
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-help-circle"
                ></vs-icon>
              </span>
              <vs-input
                class="w-full"
                v-mask="'######'"
                name="Nº da Proposta"
                id="Nº da Proposta"
                v-model="formFiltro.proposalNumber"
                :state="validateState('Nº da Proposta')"
                :danger="validateClass('Nº da Proposta')"
                val-icon-danger="clear"
                data-testId="proposal-number-input"
              />
            </vs-tooltip>
          </div>

          <div :class="`vx-col sm:w-1/9 w-full mt-3`">
            <vs-tooltip text="Insira os 6 últimos números">
              <span>
                Nº da Apólice
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-help-circle"
                ></vs-icon>
              </span>
              <vs-input
                class="w-full"
                v-mask="'######'"
                name="policy_number"
                id="policy_number"
                v-model="formFiltro.numero_apolice"
                data-testId="policy_number_filter"
              />
            </vs-tooltip>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Tipo Apólice</span>
            <v-select
              :options="listApolices"
              multiple
              name="Tipo de Apólice"
              id="Tipo de Apólice"
              v-model="formFiltro.idTipoApolices"
              :state="validateState('Tipo de Apólice')"
              :class="validateClass('Tipo de Apólice')"
              data-testId="policy-type-select"
            ></v-select>
          </div>

          <div class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Tipo de Data Inicial</span>
            <v-select
              data-testId="initial-date-type-select"
              class="w-full"
              :options="tiposDatas"
              name="Tipo de Data Inicial"
              id="Tipo de Data Inicial"
              v-model="formFiltro.tipoData"
            ></v-select>
          </div>

          <div class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Data Inicial</span>
            <datepicker
              data-testId="initial-date-datepicker"
              class="w-full"
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
            ></datepicker>
          </div>

          <div class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Data Final</span>
            <datepicker
              data-testId="final-date-datepicker"
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>

          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/6'} w-full mt-3`">
            <span>Placa</span>
            <vs-input
              data-testId="license-plate-input"
              v-mask="'AAA-#XX#'"
              class="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :state="validateState('Placa')"
              :danger="validateClass('Placa')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>

          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/3'} w-full mt-3`">
            <span>Nome do Segurado</span>
            <vs-input
              data-testId="insured-name-autocomplete"
              class="w-full"
              name="Segurado"
              id="Segurado"
              v-model="formFiltro.nomeAssociado"
            />
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Status</span>
            <v-select
              data-testId="status-advanced-select"
              :options="filteredStatus"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Status da Apólice</span>
            <v-select
              data-testId="policy-status-select"
              :options="policyStatusOptions"
              multiple
              name="Status da Apólice"
              id="Status da Apólice"
              label="label"
              v-model="formFiltro.status_apolice"
              :state="validateState('Status da Apólice')"
              :class="validateClass('Status da Apólice')"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

          <div :class="`vx-col sm:w-1/6 w-full mt-3 w-full`">
            <span>Corretora</span>
            <v-select
              data-testId="broker-select"
              :options="regionais"
              name="Corretora"
              id="Corretora"
              multiple
              v-model="formFiltro.regional"
              :state="validateState('Corretora')"
              :class="validateClass('Corretora')"
            ></v-select>
          </div>
        </div>

        <div v-if="filtroAvancado" class="vx-row pb-0 sm:pb-4">
          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/4'} w-full mt-3`">
            <span>Usuário</span>
            <v-select
              data-testId="user-select"
              :options="consultores"
              name="Usuário"
              id="Usuário"
              multiple
              v-model="formFiltro.consultor"
              :state="validateState('Usuário')"
              :class="validateClass('Usuário')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Estado</span>
            <v-select
              data-testId="state-select"
              :options="estados"
              name="Estado"
              id="Estado"
              v-model="formFiltro.estado"
              @selected="buscaDadosSelectsCidades"
              :state="validateState('Estado')"
              :class="validateClass('Estado')"
            ></v-select>
          </div>

          <div :class="`vx-col sm:w-1/4 w-full mt-3`">
            <span>Cidade</span>
            <v-select
              data-testId="city-select"
              :options="cidades"
              name="Cidade"
              id="Cidade"
              multiple
              v-model="formFiltro.cidade"
              :state="validateState('Cidade')"
              :class="validateClass('Cidade')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Origem</span>
            <v-select
              data-testId="origin-select"
              :options="origem"
              multiple
              name="Origem"
              id="Origem"
              v-model="formFiltro.origem"
              :reduce="(option) => option.value"
              :state="validateState('Origem')"
              :class="validateClass('Origem')"
            ></v-select>
          </div>

          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/6'} w-full mt-3`">
            <span>CPF/CNPJ Segurado</span>
            <vs-input
              class="w-full"
              name="CPF"
              id="CPF"
              v-model="formFiltro.cpfCnpjAssociado"
              :state="validateState('CPF')"
              :danger="validateClass('CPF')"
              v-validate="{ min: escolherCPFCNPJMin }"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              val-icon-danger="clear"
              danger-text="CPF ou CNPJ incompletos."
              data-testId="insured-cpf-cnpj-input"
            />
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3" v-if="b2c">
            <span>Origem App</span>
            <v-select
              data-testId="origin-app-select"
              :options="origemApp"
              name="Origem App"
              id="Origem App"
              v-model="formFiltro.insideApp"
              :state="validateState('Origem App')"
              :class="validateClass('Origem App')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Chassi</span>
            <vs-input
              class="w-full"
              name="chassi"
              id="chassi"
              v-model="formFiltro.chassi"
              :state="validateState('chassi')"
              :danger="validateClass('chassi')"
              v-validate="{ min: 17 }"
              val-icon-danger="clear"
              danger-text="Chassi incorreto ou incompleto"
              data-testId="chassis-input"
            />
          </div>

          <div class="vx-col sm:w-1/5 w-full mt-3">
            <span>Tipo de Cotação</span>
            <v-select
              data-testid="creation-type-select"
              :options="creationTypeOptions"
              multiple
              name="Tipo de Cotação"
              id="creation-type-select"
              label="label"
              v-model="formFiltro.creationType"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row class="flex justify-end">
          <vs-button
            data-testId="search-button"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar
          </vs-button>
          <vs-button
            data-testId="advanced-search-button"
            @click="buscaFiltrosAvancados()"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            data-testId="clear-button"
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>

<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import jwt from 'jsonwebtoken';
import originSystemApi from "@/services/origin.system.api";
import {
  DATE_TYPES,
  POLICY_STATUSES,
  CREATION_TYPES,
  STATUS_PROPOSTA,
} from '@/utils/constants';
import autoApi from '@/services/auto.api';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {
    'formFiltro.estado'(value) {
      this.formFiltro.cidade = null;
      if (value) {
        this.buscaDadosSelectsCidades(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      } else {
        this.cidades = [];
      }
    },
  },
  computed: {
    escolherCPFCNPJMask() {
      return this.formFiltro.cpfCnpjAssociado.length <= 14
        ? '###.###.###-##'
        : '##.###.###/####-##';
    },
    escolherCPFCNPJMin() {
      return this.formFiltro.cpfCnpjAssociado.length <= 14 ? 14 : 18;
    },
    policyStatusOptions() {
      return Object.keys(POLICY_STATUSES)
        .map((key) => {
          return {
            id: POLICY_STATUSES[key].id,
            label: POLICY_STATUSES[key].name,
          };
        })
        .filter((status) => status.id !== POLICY_STATUSES.OPEN.id);
    },
    creationTypeOptions() {
      return CREATION_TYPES.sort((a, b) => a.label.localeCompare(b.label));
    },
    filteredStatus() {
      const filteredStatus = this.status;
      return filteredStatus.sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  data() {
    return {
      colaboradoresCadastro: [],
      aguardeCadastro: false,
      idEmpresa: null,
      id_usuario: null,
      estados: [],
      cidades: [],
      regionais: [],
      consultores: [],
      status: [],
      languages: lang,
      regionalDefault: [],
      regionaisUsuario: [],
      filtroAvancado: false,
      usuarios_regionais: [],
      origemApp: ['Sim', 'Não'],
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tiposDatas: DATE_TYPES,
      origem: [],
      funcoesValicao: null,
      idTipoApolices: null,
      listApolices: [],
      formFiltro: this.getDefaultFormFiltro(),
    };
  },
  methods: {
    getDefaultFormFiltro() {
      return {
        idEmpresa: null,
        placa: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        cidade: null,
        estado: null,
        tipoData: DATE_TYPES[0],
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProposta: null,
        proposalNumber: null,
        tipoCotacao: null,
        cpfCnpjAssociado: '',
        chassi: null,
        idTipoApolices: null,
        status_apolice: [],
        numero_apolice: null,
        creationType: [],
      };
    },
    limparFiltro() {
      this.formFiltro = this.getDefaultFormFiltro();
      this.buscar();
    },
    dataInicio() {
      const filtroDiasAnteriores = 30;
      let dataAtual = new Date();
      const dataInicio = dataAtual.setDate(
        dataAtual.getDate() - filtroDiasAnteriores,
      );
      return dataInicio;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 5 ||
              element[campoPK] == 6 ||
              element[campoPK] == 7 ||
              element[campoPK] == 16
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }

      this.idEmpresa = this.decoded.id_empresa;
      this.id_usuario = this.decoded.id_usuario;
    },

    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service
          .post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
          .then(({ data }) => {
            data.consultores.forEach((element) => {
              this.consultores.push({
                id: element.id_usuario,
                label: element.nome,
              });
            });

            data.regionais.forEach((element) => {
              this.regionais.push({
                id: element.id_regional,
                label: element.nome,
              });
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.formFiltro.estado) {
        return;
      }

      this.$vs.loading();

      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Falha buscar cidades',
            text: e,
            color: 'danger',
          });
        });
    },
    buscar() {
      this.formFiltro.filtred = true;
      this.$emit('filtro', this.formFiltro);
    },
    async buscaColaboradoresDoCadastro() {
      const idSetorCadastro = await this.buscarIdDoSetorCadastro();
      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idSetor: idSetorCadastro.id,
        })
        .then((res) => {
          this.colaboradoresCadastro = res.data.map((colaborador) => {
            return {
              id: colaborador.idUsuario,
              label: colaborador.nome,
            };
          });
          this.colaboradoresCadastro.unshift({ label: 'Selecione', id: null });

          this.$emit('obterColaboradoresCadastro', this.colaboradoresCadastro);
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    buscarIdDoSetorCadastro() {
      return new Promise((resolve, reject) => {
        service
          .post('Setor', 'buscar-id-setor-por-nome', {
            idEmpresa: this.idEmpresa,
            nomeSetor: 'cadastro',
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((e) => {
            this.$vs.loading.close();
            reject(e);
          });
      });
    },
    buscaFiltrosAvancados() {
      if (!this.filtroAvancado) {
        this.filtroAvancado = true;
        this.buscaDadosFiltros();
        this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
      } else this.filtroAvancado = false;
    },
    getOriginSystems() {
      originSystemApi.getOriginSystems()
        .then((res) => {
          this.origem = res.map((origin) => {
            return {
              value: origin.key,
              label: origin.name,
            };
          });
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Falha ao buscar origens',
            text: e,
            color: 'danger',
          });
        });
    },
  },
  created() {
    this.getDecoded();
    this.buscaDadosSelects(
      'domStatusCotacao',
      'status',
      'nomeStatus',
      'idStatus',
    );
    this.getOriginSystems();
    this.buscaDadosSelects(
      'tipoApolices',
      'listApolices',
      'nome',
      'tipoApoliceId',
    );
    this.$validator.localize('ptBr', locale);
  },
  mounted() {},
  components: {
    Datepicker,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}

.vs-card--footer {
  margin-top: -3% !important;
}
</style>
